import React, {useContext} from "react";
import {Button, Tag} from "antd";
import {Briefcase, BriefcaseBusiness, Clock, PersonStanding} from "lucide-react";
import dayjs from "dayjs";
import {removeUnderScoreWithLowerCase} from "../../../../utility/utility";
import {useLocation, useNavigate} from "react-router-dom";
import {EditOutlined} from "@ant-design/icons";
import UserLoginContext from "../../../../context/userLoginContext";
import SectionCard from "../common/SectionCard";
import EmptyData from "../../../common/empty-data/empty-data";

const ExperienceTab = ({employeeData}: any) => {
    const navigate = useNavigate();
    const location = useLocation();
    const {user} = useContext(UserLoginContext);
    const isActiveEmployee = location.state?.isActive ?? true;
    const navigateToExperienceDetail = () => navigate(`/employee/edit/experience`, {state: {empId: employeeData.id}});
    const exp = employeeData?.experiences;
    const previousExp = exp?.previousExperiences || [];

    const formatDateToDayMonth = (dateStr?: any) => {
        const d = dayjs(dateStr?.trim(), ["DD-MM-YYYY", "YYYY-MM-DD"], true);
        return d.isValid() ? d.format("MMMM YYYY") : "";
    }

    const joiningDate = formatDateToDayMonth(employeeData?.joiningDate)
    const employmentType = removeUnderScoreWithLowerCase(employeeData?.experiences?.employmentType)

    return (
        <>
            <SectionCard
                title={"Current Employment"}
                icon={<Briefcase className={'employee-detail-lucide briefcase-icon'}/>}
                extra={
                    <div>
                        <span className="company-status-badge">Current</span>
                        {
                            user?.isAdmin && isActiveEmployee && (
                                <Button
                                    type={"link"}
                                    className={"edit-icon"}
                                    onClick={() => navigateToExperienceDetail()}
                                >
                                    <EditOutlined/>
                                </Button>
                            )
                        }

                    </div>
                }
            >
                {exp ? (
                        <div className="experience-card">
                            <div className="company-info">
                                <div className="employee-detail-avatar currentCompany">
                                    {exp?.companyName?.slice(0, 2)}
                                </div>

                                <div>
                                    <h3>{exp?.companyName}</h3>
                                    <p>
                                        {exp?.designationItem?.displayName} •{" "}
                                        {employmentType}
                                    </p>
                                    <span className="company-duration">{joiningDate} - Present </span>
                                </div>
                            </div>

                            <div className="employee-detail-skillsSection">
                                <h4>Skills Used</h4>

                                <div className="skill-group">
                                    <label>PRIMARY SKILLS</label>
                                    <div>
                                        {exp?.primarySkills?.map((skill: string, i: number) => (
                                            <Tag key={i} className="primary-tag">
                                                {skill}
                                            </Tag>
                                        ))}
                                    </div>
                                </div>

                                <div className="skill-group">
                                    <label>SECONDARY SKILLS</label>
                                    <div>
                                        {exp?.secondarySkills?.map((skill: string, i: number) => (
                                            <Tag key={i} className="secondary-tag">
                                                {skill}
                                            </Tag>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) :
                    <div>
                        <EmptyData
                            icon={<BriefcaseBusiness className={'experience-empty-data-icon'}/>}
                            title={"No Work Experience Added"}
                            subtitle={user?.isAdmin ? "Update profile to add experience" : "Showcase your work journey by adding experience"}
                        />
                    </div>
                }

            </SectionCard>

            {
                previousExp.length > 0 && (
                    <SectionCard
                        title={"Previous Experience"}
                        icon={<Clock className={'employee-detail-lucide clock-icon'}/>}
                        extra={
                            <div>
                                {
                                    user?.isAdmin && isActiveEmployee && (
                                        <Button
                                            type={"link"}
                                            className={"edit-icon"}
                                            onClick={() => navigateToExperienceDetail()}
                                        >
                                            <EditOutlined/>
                                        </Button>
                                    )
                                }
                            </div>
                        }
                    >
                        {previousExp.map((prev: any, index: number) => (
                            <div className="experience-card" key={index}>
                                <div className="company-info">
                                    <div className="employee-detail-avatar previousCompany">
                                        {prev?.companyName?.slice(0, 2)}
                                    </div>

                                    <div className="company-details">
                                        <div>
                                            <h3>{prev.companyName}</h3>
                                            <p>{prev.designationItem?.displayName}</p>
                                            <span className="company-duration">
                                            {formatDateToDayMonth(prev.duration?.startDate)} - {formatDateToDayMonth(prev.duration?.endDate)}
                                        </span>
                                        </div>

                                        <span className="company-years">
                    {prev.years} year
                  </span>
                                    </div>
                                </div>

                                <div className="previous-details">
                                    <div>
                                        <label>DURATION</label>
                                        <div className={'previous-exp-duration'}>
                                            <p>{prev.years} year</p>
                                            <p>{prev.months} month</p>
                                        </div>

                                    </div>

                                    <div>
                                        <label>ANNUAL CTC</label>
                                        <p>₹{prev.annualCTC}</p>
                                    </div>

                                    <div>
                                        <label>REASON FOR LEAVING</label>
                                        <p>{prev.reasonForLeaving}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </SectionCard>
                )
            }
        </>
    );
};

export default ExperienceTab;